import { render, staticRenderFns } from "./InvendoIdeas.vue?vue&type=template&id=6579062a&"
import script from "./InvendoIdeas.vue?vue&type=script&lang=js&"
export * from "./InvendoIdeas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports